import React, { useCallback, useState } from 'react'
import fileDownload from 'js-file-download'
import { isEmpty, join, map, omit, values } from 'lodash'

import { METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { generateMetadataNodesGroupedByTypeReport } from '../../rest'
import { MetadataNodesForm } from '../forms'

const MetadataNodesReportSection = () => {
  useDocumentTitle('Reports - Metadata Nodes')
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  const generateReport = useCallback(
    async filters => {
      try {
        let filterData = filters

        if (isEmpty(filters.metadataTypes)) {
          filterData = {
            metadataTypes: map(
              values(
                omit(METADATA_TYPES, ['DICTIONARY_WORDS', 'DIET_CATEGORIES']),
              ),
              'value',
            ),
          }
        }

        setIsGeneratingReport(true)
        const reportReponse = await generateMetadataNodesGroupedByTypeReport(
          filterData,
        )

        fileDownload(reportReponse?.data, 'MetadataNodesGroupedByType.csv')
      } catch (error) {
        let errorMessage = error.message

        const { errors } = JSON.parse(
          (await error.response?.data?.text()) || '{}',
        )

        if (!isEmpty(errors)) {
          errorMessage = join(errors, '\n')
        }

        showErrorNotification({
          message: 'Failed to generate report.',
          description: errorMessage,
          type: 'error',
          duration: 0,
        })
      } finally {
        setIsGeneratingReport(false)
      }
    },
    [setIsGeneratingReport],
  )

  return (
    <MetadataNodesForm
      onSubmit={generateReport}
      isGeneratingReport={isGeneratingReport}
    />
  )
}

export default MetadataNodesReportSection
